// extracted by mini-css-extract-plugin
module.exports = {"products":"GN","productContainer":"HN","overFlowVisible":"IN","resultsHeading":"JN","oosMessaging":"KN"};